'use client';

import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Problem', href: '#problem' },
    { label: 'Solution', href: '#solution' },
    { label: 'Market', href: '#market' },
    { label: 'Financials', href: '#financials' },
    { label: 'Invest', href: '#invest' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all backdrop-blur-xs  duration-500 ${
        scrolled ? 'nav-scrolled py-1' : 'py-3'
      }`}
    >
      <div className="w-full  mx-auto px-6 lg:px-10 flex items-center justify-between">
        {/* Logo */}
        <Link href="/homepage" className="flex items-center space-x-3">
            <div className="w-20 h-auto">
              <img
                src="/assets/images/logo.png"
                alt="Grandville Holdings Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="flex flex-col">
              <span className="font-headline text-xl text-yellow-400  font-semibold">
                Grandville Holdings
              </span>
              <span className={`font-body text-sm text-yellow-400 `}>Building What Lasts</span>
            </div>
          </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" aria-label="Main navigation">
          {navLinks?.map((link) => (
            <a
              key={link?.label}
              href={link?.href}
              className="text-sm font-medium text-white/60 hover:text-white transition-colors duration-300 relative group"
            >
              {link?.label}
              <span className="absolute bottom-0 left-0 w-0 h-px bg-yellow-accent group-hover:w-full transition-all duration-500" />
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden lg:flex items-center gap-4">
          <a
            href="#invest"
            className="btn-yellow px-5 py-2.5 rounded-full text-sm font-bold"
          >
            Request Materials
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          className="lg:hidden text-white p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <div className="w-6 flex flex-col gap-1.5">
            <span className={`h-px bg-white transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`h-px bg-white transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`h-px bg-white transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </div>
        </button>
      </div>
      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden glass-dark border-t border-green-primary/10 px-6 py-6">
          <nav className="flex flex-col gap-5" aria-label="Mobile navigation">
            {navLinks?.map((link) => (
              <a
                key={link?.label}
                href={link?.href}
                onClick={() => setMenuOpen(false)}
                className="text-base font-medium text-white/80 hover:text-yellow-accent transition-colors"
              >
                {link?.label}
              </a>
            ))}
            <a
              href="#invest"
              onClick={() => setMenuOpen(false)}
              className="btn-yellow px-5 py-3 rounded-full text-sm font-bold text-center mt-2"
            >
              Request Materials
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}